export const menu = {
    label: 'Contas de Eventos',
    icon: 'pi pi-key',
    to: '/checkins/contas-eventos',
    matchChildren: true,
    rules: ['CHECKINS-CONTAS-EVENTOS-00'],
};

export default menu;